import { memoize } from 'lodash';
import { convertWeight as convertWeightUtil } from 'utils';

export const convertWeight = () => {
  return memoize(
    (weight, gender) => {
      return convertWeightUtil(weight, gender || 'F');
    },
    (weight, gender) => {
      return `${weight}-${gender}`;
    }
  );
};



// WEBPACK FOOTER //
// ./src/filters/convertWeight.js